import React, { useContext } from 'react';
import { Col, Row } from 'reactstrap';
import { PixelContext } from '../../../context/Pixel';
import Styles from "./index.module.css";

function Social() {
    const { MetaPixel } = useContext(PixelContext);
    const links = [
      {
        "title": "@builderenovations",
        "link": "https://www.instagram.com/builderenovations",
        "image": "./assets/images/instagram.webp"
      }
    ];

    const handleLinkClick = (e, link) => {
        // Fire Meta Lead track only for socials
        if (link) {
            e.preventDefault();
            MetaPixel.track('Lead');

            setTimeout(() => {
                window.location.href = link.link;
            }, 300);
        }
    }

    return (
        <div className={`${Styles.social}`}>
            {
                links
                    ? links.map((d, i) => (
                        <Row className={`align-items-center ${i > 0 ? 'mt-3' : ''}`} key={`links-${i}`}>
                            <Col xs="12" className='text-center'>
                                <img src={require('' + d.image)} alt="" className={`img-fluid ${Styles.socialIcon}`} />
                                <a href={d.link} className={Styles.socialLink} onClick={(e) => handleLinkClick(e, d)}>
                                    {d.title}
                                </a>
                            </Col>
                        </Row>
                    ))
                    : "Loading..."
            }
        </div>
    );
}

export default Social;